import { API } from '../api';
import config from '../config';

const patientPortalApi = new API(config.PATIENT_PORTAL_API_URL_WITHOUT_PATH);

export const getQuestionnairesWithName = (url) => {
  const filter = { where: { url } };
  return patientPortalApi.get('/api/v1/Questionnaires', { filter });
};
